import hash from 'object-hash';
import useSWR from 'swr';
import { SWRCustomResponse } from '../../../hooks/types';
import { SerpInvoice } from '../../../providers/api/dtos';
import { getSerpInvoices, SerpInvoiceProviderFilters } from '../../../providers/api/serp-invoices/getSerpInvoices';
import { PaginatedResult, PaginationParams } from '../../../providers/pagination';
import { useMatchMutate } from '../../../utils/swr/swr';

export const INVOICES_SERP_RID = '/api/v1/serp/invoices';

export function useSerpInvoices(
  filters?: SerpInvoiceProviderFilters,
  pagination: PaginationParams = { size: 20 },
): SWRCustomResponse<PaginatedResult<SerpInvoice>, Error> {
  const matchMutate = useMatchMutate();
  const key = filters ? [INVOICES_SERP_RID, hash({ ...filters, ...pagination })] : null;
  const result = useSWR(key, () => getSerpInvoices(filters, pagination));

  return {
    ...result,
    mutate: () => matchMutate(INVOICES_SERP_RID),
  };
}
